<template>
    <div>
        <b-modal
            id="domainOppositionResponsibleFormModal"
            centered
            size="xl"
            no-close-on-backdrop
            ref="domainOppositionResponsibleFormModal"
            :title=" $t('domainOppositionResponsible.info')"
            :cancel-title=" $t('others.cancel_title')"
            :ok-title=" $t('others.ok_title')"
            cancel-variant="outline-secondary"
            @ok.prevent="addOrUpdate"
            hide-footer
        >
        <b-card no-body class="border mt-1">
            <b-card-header class="p-1">
              <b-card-title class="font-medium-2">
                <feather-icon icon="LockIcon" size="18" />
                <span class="align-middle ml-50">{{  $t('domainOppositionResponsible.responsible')  }}</span>
              </b-card-title>
            </b-card-header>
            <!--eslint-disable-->
            <table class="table table-striped table-bordered">
              <tbody>
                <tr v-for="domainOppositionResponsibleItem in domainOppositionResponsibleList" :key="domainOppositionResponsibleItem.id">
                  <td >
                      <b-form-checkbox @change="changeResponsible($event, domainOppositionResponsibleItem.id, domainOppositionResponsibleItem.mailContactTypeId)" />                                 
                  </td>
                  <td>{{  domainOppositionResponsibleItem.name  }}</td>
                  <td>{{  domainOppositionResponsibleItem.email  }}</td>
                  <td>
                    <b-form-select v-model="domainOppositionResponsibleItem.mailContactTypeId" value-field="id" text-field="name" :options="mailContactTypeList" />
                  </td>
                  <td>{{  domainOppositionResponsibleItem.responsibleField  }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-modal>
    </div>
</template>
<script>
export default{
  props: {
      getDomainOppositionResponsibleList: {type: Function},
    },
  data(){
    return {
        domainOppositionId: 0,
        domainOppositionResponsibleList:[],
        mailContactTypeList:[],
    }
  },
  methods:{
    changeResponsible(selected, clientResponsibleId, mailContactTypeId) {
      const controller = { name: 'DomainOppositionResponsible' }
      if (selected == true) {
        const data = { domainOppositionId: this.domainOppositionId, clientResponsibleId: clientResponsibleId, mailContactTypeId: mailContactTypeId }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/save', payload).then((response) => {
          if (response.data.resultStatus == true) {
            this.getDomainOppositionResponsibleList()
            this.$SaveAlert()
          } else {
            this.$WarningAlert(response.data.resultMessage)
          }
        })
      }
    },
    showInfo(domainOppositionId, clientId) {
      this.$refs['domainOppositionResponsibleFormModal'].show()
      this.domainOppositionId= domainOppositionId
          const data = {clientId: clientId , domainOppositionId : domainOppositionId}
          const controller = {name: 'ClientResponsible', actionName:'GetClientResponsibleListForModules'}
          const payload = {data: data, controller: controller}
          this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
              if(response.data.resultStatus == true){    
                  this.domainOppositionResponsibleList = response.data.clientResponsibleList
                  this.mailContactTypeList = response.data.mailContactTypeList
              } else {
                  this.$bvModal.hide('domainOppositionResponsibleFormModal')
                  this.$WarningAlert(response.data.resultMessage)
              }  
          }) 
      },
  }
}
</script>